import { Endpoint } from '@philips-emr/hpms-provider-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import { SsoErrorAliases as Aliases, FragmentNames } from '../../codegen';
import { FOUNDATION_ROUTES } from '../../route';

@Controller({ fragment: FragmentNames.SSO_ERROR })
class SsoErrorController {

  @OnMount(Aliases.PANEL_SSO_ERROR)
  onMountPanelError(): void {

    void HttpService.get(Endpoint.GET.SSO_ERROR_ROUTE).then((resp) => {
      const errorRoute = resp.body as string;
      HistoryService.redirect(errorRoute + '?redirect=' + FOUNDATION_ROUTES.LOGIN);
    }
    );
  }

}

export {
  SsoErrorController,
};
